import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Card, Typography } from "@mui/material";
import {
  addDays,
  addMonths,
  format,
  isSameDay,
  setDate,
  subDays,
  subMonths,
} from "date-fns";
import React, { useState, useEffect } from "react";
import "../../assets/css/MiniCalendar.css";
const MultiSelector = (props) => {
  const [useless, setUseless] = useState(0);
  const isDateGood = (date) => {
    var a = date.setHours(0, 0, 0, 0);
    var b = new Date().setHours(0, 0, 0, 0);
    return a >= b;
  };
  const getMonthDates = (date) => {
    if (!date) {
      return false;
    }
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);
    const firstDayOfCalendar = new Date(
      firstDayOfMonth.getFullYear(),
      firstDayOfMonth.getMonth(),
      firstDayOfMonth.getDate() - firstDayOfMonth.getDay()
    );
    const lastDayOfCalendar = new Date(
      lastDayOfMonth.getFullYear(),
      lastDayOfMonth.getMonth(),
      lastDayOfMonth.getDate() + (6 - lastDayOfMonth.getDay())
    );

    let dates = [];
    let currentDate = firstDayOfCalendar;
    while (currentDate <= lastDayOfCalendar) {
      dates.push(currentDate);
      currentDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + 1
      );
    }

    return dates;
  };
  console.log(props.use)
  const [currentMonth, setCurrentMonth] = useState(
    props.use[0]?new Date(props.use[0]):new Date()
  );
  useEffect(() => {
    if (props.selectedDates[0]) {
      setCurrentMonth(props.selectedDates[0]);
    }
  }, []);
  var monthDates = getMonthDates(currentMonth);
  const checkIf = (next) => {
    var finalDate = currentMonth;
    finalDate =
      next == "next" ? addMonths(finalDate, 1) : subMonths(finalDate, 1);
    if (
      getMonthDates(finalDate).find(
        (date) => isDateGood(date) && date.getMonth() == finalDate.getMonth()
      )
    ) {
      return "";
    }
    return "eee";
  };

  const handleNextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const handlePreviousMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };
  const handleSelectDate = (date) => {
    var e = props.selectedDates.slice();
    if (e.find((val) => isSameDay(val, date))) {
      props.handleDateChange(e.filter((val) => !isSameDay(val, date)));
    } else {
      e.push(date);
      props.handleDateChange(e);
    }
    setUseless(useless + 1);
  };

  var weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return (
    <div style={{ display: "flex", gap: "20px" }}>
      <div className="calendar-container" style={{ width: "100%", flex: 1.4 }}>
        {" "}
        {!currentMonth ? (
          <div style={{ position: "relative" }}>
            <div
              className="calendar-grid"
              style={{ height: "310px", opacity: "40%" }}
            >
              {weekdays.map((day) => (
                <div key={day} className="weekday">
                  {day.toUpperCase().slice(0, 3)}
                </div>
              ))}
              {getMonthDates(new Date()).map((date, index) => (
                <div
                  style={{
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div key={index} className="disabled">
                    {date.getDate()}
                  </div>
                </div>
              ))}
            </div>
            <Card
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "240px",
                border: "1px solid black",
                padding: "20px",
                fontWeight: 500,
              }}
            >
              <Typography>No available dates for this event</Typography>
            </Card>
          </div>
        ) : (
          <div>
            <div className="header">
              <h3 className="month">
                {currentMonth.toLocaleString("default", { month: "long" })}{" "}
                {currentMonth.getFullYear()}
              </h3>
              <div style={{ display: "flex" }}>
                <ChevronLeft
                  disabled
                  className={`prev-btn ${checkIf("prev")}`}
                  onClick={handlePreviousMonth}
                />
                <ChevronRight
                  className={`next-btn ${checkIf("next")}`}
                  onClick={handleNextMonth}
                />
              </div>
            </div>

            <div className="calendar-grid" style={{ height: "310px" }}>
              {weekdays.map((day) => (
                <div key={day} className="weekday">
                  {day.toUpperCase().slice(0, 3)}
                </div>
              ))}

              {monthDates.map((date, index) => (
                <div
                  style={{
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  <div
                    onClick={
                      !isDateGood(date)
                        ? console.log()
                        : () => handleSelectDate(date)
                    }
                    key={index}
                    className={`calendar-date ${
                      !isDateGood(date) ? "disabled" : ""
                    } ${
                      date.getTime() === new Date().setHours(0, 0, 0, 0)
                        ? "today"
                        : ""
                    } ${
                      props.selectedDates.find((val) => isSameDay(val, date))
                        ? "selected"
                        : ""
                    }`}
                  >
                    {date.getDate()}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default MultiSelector;
